<div class="sp-dialog__max-width-l sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">{{ 'STORES.SET_PLUGIN_CREDENTIALS_DIALOG_CTA' | translate }}</h3>

    <form
      [formGroup]="store_plugin_credentials_form_group"
      class="sp-margin__top-x2">
      <mat-form-field
        class="sp-width__full sp-form-field sp-margin__bottom-x2 sp-form-field__client-credentials"
        appearance="fill"
        color="accent">
        <mat-label> Client ID </mat-label>
        <input
          matInput
          type="text"
          formControlName="client_id" />
        <mat-icon
          (click)="onCopyClick('client_id')"
          matSuffix
          class="sp-color__accent sp-cursor__pointer">
          content_copy
        </mat-icon>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-form-field sp-margin__bottom-x2 sp-form-field__client-credentials-secret"
        appearance="fill"
        color="accent">
        <mat-label> Client secret </mat-label>
        <input
          matInput
          [type]="is_secret_visible ? 'text' : 'password'"
          formControlName="client_secret" />
        <mat-icon
          matSuffix
          class="sp-color__accent sp-cursor__pointer"
          (click)="is_secret_visible = !is_secret_visible">
          {{ is_secret_visible ? 'visibility_off' : 'visibility' }}
        </mat-icon>
        <mat-icon
          (click)="onCopyClick('client_secret')"
          matSuffix
          class="sp-color__accent sp-cursor__pointer">
          content_copy
        </mat-icon>
      </mat-form-field>
    </form>

    <p class="sp-color__primary sp-margin__top-x4">{{ 'STORES.SET_PLUGIN_CREDENTIALS_DIALOG_MESSAGE' | translate }}</p>

    <app-shared-button
      class="sp-width__full sp-display__block sp-margin__top-x2"
      [button_class]="'sp-button__main'"
      [spinner_class]="'sp-spinner__main'"
      [cta]="'STORES.SET_PLUGIN_CREDENTIALS_DIALOG_CTA'"
      [is_disabled]="is_set_plugin_credentials_running"
      [is_spinner_visible]="is_set_plugin_credentials_running"
      (click)="onConfirmClick()"></app-shared-button>
  </div>
</div>
